export default (context, inject) => {
  const kbmb = (number) => {
    if (number < 1024) {
      return `${number}kb/s`;
    } else if (number >= 1024000) {
      return `${Math.floor(number / 1024000)}Gb/s`;
    } else {
      return `${Math.floor(number / 1024)}Mb/s`;
    }
  };
  inject('kbmb', kbmb);
  context.$kbmb = kbmb;
};
